var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeenInClassIcon = function SvgSeenInClassIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M10 1a9 9 0 1 0 9 9 9.014 9.014 0 0 0-9-9m4.528 7.214-4.016 5.358a2.05 2.05 0 0 1-1.661.831c-.55 0-1.079-.22-1.468-.61l-2.077-2.076a1.038 1.038 0 0 1 1.468-1.468l1.786 1.828a.346.346 0 0 0 .526 0l3.78-5.123a1.042 1.042 0 1 1 1.662 1.26"
  })));
};
export { SvgSeenInClassIcon as ReactComponent };